import { EMOJI_ITEMS } from "../../lib";

/**
 * Получает символ эмодзи по его ID
 * @param id - ID эмодзи
 * @returns Символ эмодзи или пустую строку, если не найден
 */
export const getEmojiSymbolById = (id: string): string => {
    const emojiItem = EMOJI_ITEMS[id];
    return emojiItem?.symbol || "";
};
